import { render, staticRenderFns } from "./menuSort.vue?vue&type=template&id=234b13a6&scoped=true"
import script from "./menuSort.vue?vue&type=script&lang=js"
export * from "./menuSort.vue?vue&type=script&lang=js"
import style0 from "./menuSort.vue?vue&type=style&index=0&id=234b13a6&prod&lang=css"
import style1 from "./menuSort.vue?vue&type=style&index=1&id=234b13a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234b13a6",
  null
  
)

export default component.exports